/* eslint-disable no-unused-vars */
/* eslint-disable semi */
// ** Logo
import { Spinner } from "reactstrap";
const SpinnerComponent = () => {
  return (
    <div className="fallback-spinner app-loader">
      <Spinner />
    </div>
  );
};

export default SpinnerComponent;
